// Etapas e relatórios de acompanhamento do projeto (25/10/2026).
export default {
  projectStages: {
    title: 'Etapas',
    edit: 'Editar etapas',
    define: 'Definir etapas',
    emptyText: 'Sem etapas: o relatório mostra só o progresso geral. Defina as etapas para o cliente ver onde vocês estão.',
    dialogTitle: 'Etapas do projeto',
    dialogText: 'Na ordem em que acontecem. Cada tarefa do projeto pode pertencer a uma etapa; excluir uma etapa não exclui as tarefas.',
    name: 'Etapa {n}',
    placeholder: 'Ex.: Diagnóstico',
    add: 'Adicionar etapa',
    remove: 'Remover a etapa',
    moveUp: 'Subir a etapa',
    moveDown: 'Descer a etapa',
    saved: 'Etapas salvas.',
    state: { done: 'Concluída', current: 'Em andamento', upcoming: 'A seguir' },
    doneOn: 'Concluída em {date}',
    progress: '{progress}% · {done} de {total}',
    until: 'até {date}',
    forecast: 'Previsão {date}',
    tasks: 'Nenhuma tarefa | 1 tarefa | {n} tarefas',
    toPlan: 'A planejar',
    // The stage on the task and in the project model.
    field: 'Etapa',
    none: 'Sem etapa',
    noStages: 'O projeto não tem etapas',
    modelTitle: 'Etapas',
    modelHint: 'O projeto criado com o modelo ganha estas etapas, e cada tarefa vai para a sua.',
  },
  projectReports: {
    tab: 'Relatórios',
    fromProject: 'O relatório é do cliente: um só, com todos os projetos em andamento dele.',
    kind: { weekly: 'Relatório semanal' },
    number: '{kind} nº {n}',
    status: { draft: 'Rascunho', sent: 'Enviado' },
    health: { on_track: 'No prazo', attention: 'Atenção', late: 'Atrasado' },
    // Settings (the day agreed with the customer).
    settings: {
      title: 'Envio ao cliente',
      enabled: 'Preparar o relatório toda semana',
      enabledHint: 'No dia combinado, às 7h, o rascunho dos últimos 7 dias fica pronto e {name} recebe um aviso para revisar e enviar.',
      enabledHintNobody: 'No dia combinado, às 7h, o rascunho dos últimos 7 dias fica pronto para revisar e enviar.',
      weekday: 'Dia combinado',
      weekdays: { 1: 'Segunda-feira', 2: 'Terça-feira', 3: 'Quarta-feira', 4: 'Quinta-feira', 5: 'Sexta-feira', 6: 'Sábado', 7: 'Domingo' },
      to: 'Para',
      toHint: 'Os responsáveis do cliente, separados por vírgula.',
      cc: 'Cópia',
      ccHint: 'Quem acompanha pela equipe.',
      contacts: 'Contatos do cliente',
      useStandardCc: 'Usar a cópia padrão',
      projects: 'Entram no relatório:',
      noProjects: 'nenhum projeto em andamento',
      save: 'Salvar',
      saved: 'Envio ao cliente salvo.',
    },
    list: {
      title: 'Relatórios',
      generate: 'Gerar relatório agora',
      generateHint: 'O rascunho cobre os últimos 7 dias. Um rascunho aberto passa para o período novo.',
      empty: 'Nenhum relatório ainda.',
      emptyText: 'Gere o primeiro agora ou combine o dia de envio com o cliente acima.',
      sentOn: 'Enviado em {date} para {to}',
      automatic: 'Automático',
    },
    // The review screen.
    page: {
      back: 'Voltar ao projeto',
      backCustomer: 'Voltar ao cliente',
      projects: 'Nenhum projeto | 1 projeto | {n} projetos',
      period: 'Período',
      review: 'Revisão',
      preview: 'Prévia',
      previewHint: 'Como o cliente vai ler. O PDF tem o mesmo conteúdo, com a identidade da Aubaine.',
      health: 'Situação',
      automaticShort: 'Automática',
      calculated: 'Pelas tarefas e prazos: {value}.',
      healthNote: 'Motivo',
      healthNotePlaceholder: 'Ex.: aguardando o acesso ao banco para seguir.',
      summary: 'Resumo do período',
      summaryHint: 'Duas a cinco frases: onde estamos, o que avançou e o que vem a seguir.',
      summaryPlaceholder: 'Escreva o resumo ou use a sugestão da IA.',
      suggest: 'Sugerir com IA',
      suggesting: 'Escrevendo…',
      suggested: 'Sugestão da IA no resumo. Revise antes de enviar.',
      undoSuggestion: 'Desfazer',
      attention: 'Pontos de atenção',
      attentionHint: 'Opcional. As tarefas atrasadas já entram sozinhas.',
      save: 'Salvar',
      saved: 'Relatório salvo.',
      unsaved: 'Alterações não salvas',
      pdf: 'Ver PDF',
      send: 'Enviar por e-mail',
      resend: 'Enviar de novo',
      deleteDraft: 'Descartar rascunho',
      deleteTitle: 'Descartar este rascunho?',
      deleteText: 'O que foi escrito no rascunho se perde. Um novo pode ser gerado a qualquer momento.',
      sentBanner: 'Enviado em {date} por {name} para {to}. Um relatório enviado não muda mais.',
      notFound: 'Relatório não encontrado',
      notFoundText: 'Ele pode ter sido descartado.',
    },
    // The preview (the same sections as the PDF).
    preview: {
      progress: 'Progresso',
      averageProgress: 'Progresso médio',
      projects: 'Projetos',
      meetings: 'Reuniões do período',
      waitingProject: 'Projeto',
      noProjects: 'Nenhum projeto em andamento neste período.',
      currentStage: 'Etapa atual',
      nextMeeting: 'Próxima reunião',
      allDone: 'Concluídas',
      overall: 'Progresso geral',
      tasksDone: '{done} de {total} tarefas concluídas',
      dates: 'Início em {start} · Previsão de término em {end}',
      startOnly: 'Início em {start}',
      whereWeAre: 'Onde estamos',
      summary: 'Resumo do período',
      attention: 'Pontos de atenção',
      late: 'Em atraso',
      lateItem: 'venceu em {date} · há {days} dias',
      waiting: 'Precisamos de vocês',
      waitingWhat: 'O que precisamos',
      waitingWho: 'Com quem',
      waitingUntil: 'Até',
      done: 'O que fizemos',
      completed: 'Concluído',
      meeting: 'Reunião',
      decisions: 'Decisões',
      agreed: 'Combinado',
      followUps: 'Acompanhamentos',
      nothing: 'Nenhum registro neste período.',
      next: 'Próximos passos',
      noSummary: 'Sem resumo: a seção não entra no PDF.',
    },
    email: {
      title: 'Enviar o relatório por e-mail',
      to: 'Para',
      cc: 'Cópia',
      subject: 'Assunto',
      body: 'Mensagem',
      signature: 'A sua assinatura entra no final.',
      viaGmail: 'Sai pelo seu Gmail e fica nos seus Enviados.',
      send: 'Enviar',
      sent: 'Relatório enviado para {to}.',
      sentGmail: 'Relatório enviado pelo Gmail para {to}.',
      freezes: 'Ao enviar, o relatório fica como está: depois não muda mais.',
    },
  },
  // Follow-ups marked "Interno" never go to the customer's report.
  followUpInternal: {
    label: 'Interno',
    hint: 'Fica só com a equipe: não vai para o relatório do cliente.',
    pill: 'Interno',
    make: 'Marcar como interno',
    unmake: 'Mostrar no relatório',
  },
}
